import { render, staticRenderFns } from "./NavigationBookmarks.vue?vue&type=template&id=fe5ae91a&scoped=true"
import script from "./NavigationBookmarks.vue?vue&type=script&lang=js"
export * from "./NavigationBookmarks.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Checkbox.css?vue&type=style&index=0&id=fe5ae91a&prod&scoped=true&lang=css&external"
import style1 from "./NavigationBookmarks.vue?vue&type=style&index=1&id=fe5ae91a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5ae91a",
  null
  
)

export default component.exports